import { useCallback, useEffect, useState } from "react";
import { EmptyState } from "@/components/bits";
import { KanbanBoard } from "@/components/KanbanBoard";
import api from "@/lib/api";

export default function Pipeline() {
  const [apps, setApps] = useState(null);

  const load = useCallback(() => {
    api.get("/employer/applications").then(({ data }) => setApps(data.applications)).catch(() => setApps([]));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (!apps) return <p className="text-muted-foreground">Loading pipeline…</p>;

  return (
    <div data-testid="pipeline-page">
      <p className="text-sm text-muted-foreground mb-6">
        All candidates across your jobs. Drag cards between stages or use the move menu — candidates are notified automatically.
      </p>
      {apps.length === 0 ? (
        <EmptyState
          title="No candidates in the pipeline yet"
          description="Once your published jobs receive applications, they will appear here."
          testId="pipeline-empty"
        />
      ) : (
        <KanbanBoard applications={apps} onRefresh={load} />
      )}
    </div>
  );
}
